import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import 'github-fork-ribbon-css/gh-fork-ribbon.css'

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
document.getElementById('root')
);